import { head, prop } from 'ramda'
import { parse } from '@datasert/cronjs-parser'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { changeCronValue } from './_helpers/cron'
import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../EditableSentence'
import Text from '../../../../../packages/kiti/components/presentation/Text'

const DAYS = [
  {
    id: 1,
    name: 'Segunda'
  },
  {
    id: 2,
    name: 'Terça'
  },
  {
    id: 3,
    name: 'Quarta'
  },
  {
    id: 4,
    name: 'Quinta'
  },
  {
    id: 5,
    name: 'Sexta'
  },
  {
    id: 6,
    name: 'Sabado'
  },
  {
    id: 0,
    name: 'Domingo'
  }
]

const DayOfWeekSentence = () => {
  const form = useForm()
  const { t } = useTranslation('triggers')
  const { handleChange } = useFormState()

  if (form.event !== 'every_week') return false

  const frequency = head(parse(form.frequency || '* * * * *')?.expressions)
  const value = frequency?.day_of_week?.values
  const hasManyDays = value?.length > 1

  const onChangeDays = days => {
    days = days.sort().join(',')
    handleChange('frequency', changeCronValue(frequency, 'dayOfWeek', days))
  }

  return (
    <>
      <Text size="h2">
        {' '}
        no{hasManyDays && 's'} dia{hasManyDays && 's'}{' '}
      </Text>

      <EditableSentence
        field="days"
        label={
          DAYS?.filter(item => value?.includes(item.id))
            ?.map(item => item.name)
            .join(', ') || '_____'
        }
        value={value}
        onChange={onChangeDays}
        options={DAYS}
        truncate={15}
        width={12}
        disableCloseOnChange
        disableCloseOnBlur
        multiple
        selectOnlyId
      />
    </>
  )
}

export default DayOfWeekSentence
